import Drawer from '@mui/material/Drawer';
import Hidden from '@mui/material/Hidden';
import clsx from 'clsx';
import AppScrollbar from 'main/core/AppScrollbar';
import {useLayoutContext} from 'main/utility/AppContextProvider/LayoutContextProvider';
import {useSidebarContext} from 'main/utility/AppContextProvider/SidebarContextProvider';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {toggleNavCollapsed} from 'redux/actions';
import AppLogo from '../components/AppLogo';
import MainSidebar from '../components/MainSidebar';
import UserInfo from '../components/UserInfo';
import VerticalNav from '../components/VerticalNav';

const AppSidebarDefault = {
  variant: '',
  position: 'left',
};
const AppSidebar = (props = {AppSidebarDefault}) => {
  const dispatch = useDispatch();
  const navCollapsed = useSelector(({settings}) => settings.navCollapsed);
  const {footer, footerType} = useLayoutContext();
  const {sidebarTextColor} = useSidebarContext();
  const handleToggleDrawer = () => {
    dispatch(toggleNavCollapsed());
  };

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor={props.position}
          open={navCollapsed}
          onClose={() => handleToggleDrawer()}
          classes={{
            root: clsx(props.variant),
            paper: clsx(props.variant),
          }}
          style={{position: 'absolute'}}
        >
          <MainSidebar>
            <AppLogo />
            <AppScrollbar
              sx={{
                py: 2,
                height: 'calc(100vh - 54px - 60px) !important',
                borderTop: (theme) => `solid 1px ${theme.palette.divider}`,
                mt: 0.5,
              }}
            >
              <VerticalNav />
            </AppScrollbar>
            <UserInfo color={sidebarTextColor} />
          </MainSidebar>
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <MainSidebar>
          <AppLogo />
          <AppScrollbar
            className={clsx({
              'has-footer-fixed': footer && footerType === 'fixed',
            })}
            sx={{
              py: 2,
              flexGrow: 1, // FILL: Takes only what's available
              minHeight: 0, // SHRINK: Allows the menu to scroll instead of pushing
              borderTop: (theme) => `solid 1px ${theme.palette.divider}`,
              mt: 0.5,
            }}
          >
            <VerticalNav />
          </AppScrollbar>
          <UserInfo color={sidebarTextColor} />
        </MainSidebar>
      </Hidden>
    </>
  );
};

export default AppSidebar;

AppSidebar.propTypes = {
  position: PropTypes.string,
  variant: PropTypes.string,
};
